var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9395,
    cy: 14,
    r: 13.5,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7959_149920",
    transform: "translate(-0.0192308) scale(0.0384615)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7959_149920",
    width: 27,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASRSURBVHgBtVZNaFxVFP7u+5uZTFsnvzZQyMQkGrqwodguhOILIoIg9QfduEgClu7MoLa4KdqdoItx3UWSnSBqQChISzMh7gRJApWWajL+JrZN5tWZzMx7b969nvte8mbeZPKzsB/ceffn3POdc+45dy6wjYyZSuExoFGvEkwcT3fqyULuwlNTf3w4aOJ/wCrpufXuwFynfqSwQ6jJH91TzSIXuH63On72hDH+++WhPAObrjnOTH82nz80QSad0gxjkjNkltfc1ELe9ucNkRgHrCyTg0vneucYY+bOpuFuDef6DMQ0WhbI0dRMd9LN7UWyXlZHVKZMCjDTrgnc+tXGymYtXBdC5D5bWBtlGTOdMrhTaFZwNMbwxsk4ff1I41ibC10Tu4g8rqCwpfv9h2WO63eqKNp8l5yjlNsV7IGiLfDlchVLa4GFNa+1aNkJ5ilsmL1daUkkkc1ZlpLN5S2ALbYSsD2Bhd9sag4qjtpSSYnIfqCzkecjQ9gawte/bS5fwj5YIqunfypjsxydl+Nvliv++n5ggtXJKBEXcQBkWPObUcvlWJ7TQRAQSyGZCnbqoA1nT+h4ulOPzMmxnD8IbFt/4BnY/H7CLw7ESKmxhxGGXyb7gYP7+v2ihkdh1KICfR2M6k1BR0xHZ1uQHEKwqJLtqJ7q1THQqaHg2Fj6m+8Kt+r6tYpw99WXeqcHu5SxfqqGZ3oY4lTQZVtFxa5noawzWW87+Leswa3VSyIZ9xA3PFRr8nyBO/c5VjbEF1du/JWpe0b4wNRyTChjO2PPY3hUCojUbT7FixhMBc2oBX1BX4vke1KcDKVbqEc2VSZH/sqNQKYevAYiX7EiYNsMlWrd8liMo/1oXaZQUGC7DZ4ldmemAnaePtmgLzd9kk5RPM1GIUYTPR01xGMCW3R7/FyKQ2u6RBiNb5dieOBoiBkC3e0138hG0GhE6g/JVNUz0QKJmEeELtq6PNwThq+wETWVYYUZ6HrS9eViRsuaS9ExmLLjh1Flvqu7IL2LE+HJBLX2Khw36lq6y8bl4/f9vjzjZq92oCpc6p/1yWxXNdEgJ6hfddi2IP0DJIPM0LWo5apa37RVUcJSiFMEGIsYbYaeFSvaPK2lGxUVHilwXQZNKiRpmdbNlissqL1iRcX6Q83PTl0XaH8iapRgbCkkI4tyFP5INh47ylGwVD8JHKqlWpnhT7r5765vhTJn+o7gmKiBE4ksD1kGcl8zGBezIRm5MAtDn4qEiEgScR7UUscAykMvY+a7H/H1zZuhzJuvnMbkq2cQu/c9lNIKknqwrxmeGvzL+0v0zrAoIrtu/mSbsKrPvpYvPXfRJ/znwUZkvbRV9uflujP4Qj7ZxvPNOijwi/2fBu+YsKi54POMKSN0CDk6hnnOkev//Jfc3LfDqWJhI5uIJ8YuvvM63pt4O1RUtV0US0Uq/MoM2p/PnH7/mrV6aWhEEcKkYz4P+a4RPLzkw5xZ/Wg4jWrVkl6iBea+upYhYz6mbuP70hKCXx1960K21R752tqJXITsMJibmkohVa2TWXFrdGLCOuz+/wAt7OCrNvRoMgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBear);
export default __webpack_public_path__ + "static/media/bear.1650a80460436ef146b1d0db390ce95c.svg";
export { ForwardRef as ReactComponent };